import { REACT_APP_API_URL } from "./api_common"

export function ucFirst(string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export function extractUriParameter(uri, parameter) {
  const url = new URL(REACT_APP_API_URL + uri)
  const params = new URLSearchParams(url.search)
  return params.get(parameter)
}

export function nl2br(text) {
  return text.replace(/\n/g, "<br/>")
}

export function shuffleArray(array) {
  let currentIndex = array.length

  while (currentIndex != 0) {
    let randomIndex = Math.floor(Math.random() * currentIndex)
    currentIndex--
    ;[array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]]
  }

  return array
}
